import { render, staticRenderFns } from "./ApplicantOnboardingAddress.vue?vue&type=template&id=3925e2f0&"
import script from "./ApplicantOnboardingAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingAddress.vue?vue&type=style&index=0&id=3925e2f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports